import { frontendURL } from '../../../../helper/URLHelper';
import {
    ROLES,
    CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import SettingsWrapper from '../SettingsWrapper.vue';
import ScheduledMessagesHome from './Index.vue';

export default {
    routes: [
        {
            path: frontendURL('accounts/:accountId/settings/scheduled-messages'),
            component: SettingsWrapper,
            children: [
                {
                    path: '',
                    redirect: to => {
                        return { name: 'scheduled_messages_list', params: to.params };
                    },
                },
                {
                    path: 'list',
                    name: 'scheduled_messages_list',
                    meta: {
                        permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
                    },
                    component: ScheduledMessagesHome,
                },
            ],
        },
    ],
};
